/**
* env统一导出文件
**/
import ConfigDev from './env.dev.js';
import Config from './env.js';
import ExPandsConfig from './staging/env.stag.js';

const exportConfig = process.env.NODE_ENV === 'development' ? {...Config, ...ConfigDev} : {...Config, ...ExPandsConfig};
export default exportConfig;